import allImgPaths from "assets/images";
import DonutChart from "components/common/charts/DonutChart";
import React, { useState } from "react";
import InsightCardsOptions from "./InsightCardsOptions";
import { Modal } from "components/common/modal/Modal";
import { HeaderModal } from "components/common/modal/Header";
import { Body } from "components/common/modal/Body";

const BudgetSplit = () => {
  const [showOptions, setShowOptions] = useState(false);
  const [openMaximizeModal, setOpenMaximizeModal] = useState(false);

  const MaximizeModal = () => {
    return (
      <Modal className={"modal-wrapper max-w-[690px] relative"} isShow={openMaximizeModal}>
		<img
			className="cursor-pointer absolute top-3 right-3 rounded-xl"
			id="modal-toggle"
			src={allImgPaths.closeIcon}
			onClick={() => setOpenMaximizeModal(false)}
			alt="close icon"
		/>
        <Body title="header" isShowBody={true} className="">
          <div className="flex items-center bg-[#fff] py-3.5 rounded-xl">
            <DonutChart
              showLegends={false}
              colors={["#1808C4", "#1E0AF5", "#4B3BF7", "#786CF9", "#D0D5DD"]}
              series={[44, 89, 53, 90, 150]}
              labels={["Maybe", "Yes", "No", "No response"]}
			  height="290"
			  width="320"
            />
            <div className="origin-left scale-[1.2]">
              {/* Heading */}
              <div className="flex items-center justify-between mb-5">
                <div className="flex items-center gap-x-2">
                  <h4 className="text-base font-interSemiBold text-[#101828]">Budget Split</h4>
                  <div className="">
                    <img className="cursor-pointer" src={allImgPaths.questionMarkIcon} alt="" />
                  </div>
                </div>
              </div>

              {/* Time */}
              <p className="flex items-center gap-x-1 mb-2">
                <span className="text-[#475467] font-interMedium text-sm">Current balance</span>
              </p>

              {/* Date */}
              <p className="text-[#101828] text-2xl font-interSemiBold mb-2">$30k</p>

              {/* Venue */}
              <p className="text-sm font-interMedium text-[#079455]">($0k of $30k used)</p>
            </div>
            
          </div>
        </Body>
      </Modal>
    );
  };

  return (
    <>
      <div className="flex items-center bg-[#fff] rounded-xl border border-[#EAECF0] pr-6 py-3.5 w-[calc(33%_-_12px)]">
        <DonutChart
          showLegends={false}
          colors={["#1808C4", "#1E0AF5", "#4B3BF7", "#786CF9", "#D0D5DD"]}
          series={[44, 89, 53, 90, 150]}
          labels={["Maybe", "Yes", "No", "No response"]}
        />
        <div className="w-full">
          {/* Heading */}
          <div className="flex items-center justify-between mb-5">
            <div className="flex items-center gap-x-2">
              <h4 className="text-base font-interSemiBold text-[#101828]">Budget Split</h4>
              <div className="">
                <img className="cursor-pointer" src={allImgPaths.questionMarkIcon} alt="" />
              </div>
            </div>

            <div
              className="p-1 cursor-pointer relative hover:bg-[#f2f4f7] rounded w-5 focus-within:bg-[#f2f4f7]"
              onClick={() => setShowOptions(!showOptions)}
            >
              <img className="mx-auto" src={allImgPaths.threeVerticleDotsIcon} alt="three dots" />
              <InsightCardsOptions
                isShow={showOptions}
                openMaximizeModal={() => setOpenMaximizeModal(true)}
                chartName = 'donut_chart'
                downloadChartName = 'budgetSplit'
              />
            </div>
          </div>

          {/* Time */}
          <p className="flex items-center gap-x-1 mb-2">
            <span className="text-[#475467] font-interMedium text-sm">Current balance</span>
          </p>

          {/* Date */}
          <p className="text-[#101828] text-2xl font-interSemiBold mb-2">$30k</p>

          {/* Venue */}
          <p className="text-sm font-interMedium text-[#079455]">($0k of $30k used)</p>
        </div>
      </div>
      <MaximizeModal />
    </>
  );
};

export default BudgetSplit;
